const CTAButton = (props) => {
    return (
        <button className={ props.CTAButtonStyle }>Action</button>
    )
};

export default CTAButton;